import { useState } from 'react';

import SearchInput from '@components/common/SearchInput';

import { Icons } from '@icons/icons';

import styles from './FlatTreeXMLSearch.module.scss';

interface ISearchProps {
	onSearch: (value: string) => void;
	found: string[];
	jumpTo: (sign: number) => void;
	setSearchValue: (value: string) => void;
	searchValue: string;
}

const FlatTreeXMLSearch = ({
	onSearch,
	found,
	jumpTo,
	setSearchValue,
	searchValue,
}: ISearchProps) => {
	const [counter, setCounter] = useState(0);

	const updateCounter = (delta: number) => {
		setCounter((prev) => {
			const newCounter = (prev + delta + found.length) % found.length;

			jumpTo(newCounter);

			return newCounter;
		});
	};

	const onChange = (value: string) => {
		setSearchValue(value);
		onSearch(value);
		setCounter(0);
	};

	const onClear = () => {
		setSearchValue('');
		setCounter(0);
	};

	const stepBack = () => updateCounter(-1);
	const stepForward = () => updateCounter(1);

	const searchResultMessage = found.length
		? `${counter + 1}/${found.length}`
		: searchValue
			? 'No results'
			: '';

	return (
		<div className={styles.search}>
			<SearchInput
				containerClassname={styles.fullWidth}
				delay={0}
				isClearable
				onClear={onClear}
				onSearch={onChange}
				placeholder='Search by attribute and value'
				searchThreshold={0}
			/>
			<div className={styles.result}>
				{searchResultMessage}
				{!!found.length && (
					<div className={styles.control}>
						<div
							className={styles.controlButton}
							onClick={stepBack}
						>
							{Icons.triangleLeft()}
						</div>
						<div
							className={styles.controlButton}
							onClick={stepForward}
						>
							{Icons.triangleRight()}
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default FlatTreeXMLSearch;
